import { NgModule } from '@angular/core';
import { SubsetFieldNamePipe } from 'app/modules/dossier-area/pipes/subset-field-name/subset-field-name.pipe';

@NgModule({
  imports: [],
  declarations: [SubsetFieldNamePipe],
  exports: [SubsetFieldNamePipe],
})
export class SubsetFieldNameModule {}
